<template>
  <el-dialog
   title="出售"
    :visible.sync="dialogDel"
    width="366px"
    :close-on-click-modal="false"
  >
    <!-- <h1 style="text-align: center;font-size: 18px;color: #222;font-weight: bold;">出售</h1> -->
    <div class="del_icon">是否要一键出售所有商品?</div>
    <div class="del_icon" style="color: #F6A944;">（若用户为服务商可自行出售）</div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogDel = false">否</el-button>
      <el-button type="primary" @click="Removes">是</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogDel: false,
    };
  },
  methods: {
    show() {
      this.dialogDel = true;
    },
    Removes() {
      this.$parent.handleSell()
      this.dialogDel = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  .el-dialog__header {
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    line-height: 0px;
    color: #000000;
    .el-dialog__title{
        display: inline-block;
        width: 100%;
        text-align: center;
    }
  }
  .el-dialog__body {
    padding: 10px 20px 10px 20px;
  }
  .el-dialog__footer{
    display: flex;
    justify-content: center;
    .el-button{
      width: 82px;
      height: 36px;
      line-height: 0;
    }
  }
}
.del_icon {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 24px;
  color: #222222;
  text-align: center;
  .el-icon-warning{
    font-size: 40px;
  }
}
.el-icon-warning {
  color: red;
}
</style>